<div class="center">
  <div>
  <img class="xero-logo" src="../../../../../../assets//pos/xero-connected-app.png">
  <div class="waiting">{{'onboarding.messages.finishing_off' | translate}}</div>
  </div>
</div>